export default __webpack_public_path__ + "static/media/stealthmode.3e6d2143.png";